export const GET_CREDIT_APPLICATIONS = 'GET_CREDIT_APPLICATIONS'
export const GET_CREDIT_APPLICATION = 'GET_CREDIT_APPLICATION'
export const CREDIT_APPLICATIONS_LOADING = 'CREDIT_APPLICATIONS_LOADING'
export const GET_POSSIBLE_CONTACTS = 'GET_POSSIBLE_CONTACTS'
export const CLEAR_POSSIBLE_CONTACTS = 'CLEAR_POSSIBLE_CONTACTS'
export const GET_APPLICATION_PREVIEW = 'GET_APPLICATION_PREVIEW'
export const UPDATE_CREDIT_APPLICATION = 'UPDATE_CREDIT_APPLICATION'
export const GET_CEF_LOANS = 'GET_CEF_LOANS'
export const GET_CEF_OWNERS = 'GET_CEF_OWNERS'
export const GET_CEF_RESIDENCES = 'GET_CEF_RESIDENCES'
export const GET_CEF_PAST_EMPLOYMENTS = 'GET_CEF_PAST_EMPLOYMENTS'
export const GET_CEF_BANK_REFERENCES = 'GET_CEF_BANK_REFERENCES'
export const GET_CEF_PERSONAL_REFERENCES = 'GET_CEF_PERSONAL_REFERENCES'
export const ASSIGN_CREDIT_APPLICATIONS = 'ASSIGN_CREDIT_APPLICATIONS'
